"use client";

import { useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

interface BayHarborHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function BayHarborHero({ h1, subhead, zips }: BayHarborHeroProps) {
  const { t, currentLang } = useLanguage();
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      {!imgFailed && (
        <img
          src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/bd2499d8-debf-4747-a18e-6d4b3ae9f63e_Sliding-Door-Repair-Miami-2.png?v=a0c53dd0158734361bfa1e21308c8560"
          alt={currentLang === "es" ? "Reparaci\u00F3n de ventanas en Bay Harbor Islands Miami" : "Window repair in Bay Harbor Islands Miami"}
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => setImgFailed(true)}
        />
      )}
      {imgFailed && (
        <div className="absolute inset-0 bg-[#064e3b]" />
      )}
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-10 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-[#fbbf24] mb-6 font-bold">
          {currentLang === "es" ? "REPARACI\u00D3N DE VENTANAS BAY HARBOR ISLANDS" : "BAY HARBOR ISLANDS WINDOW REPAIR"}
        </p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
          {h1 || t("bayHarbor.h1")}
        </h1>
        <p className="max-w-2xl mx-auto text-white/90 text-lg mb-10 leading-relaxed">
          {subhead || t("bayHarbor.subhead")}
        </p>
        {zips && zips.length > 0 && (
          <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
            {zips.map((zip) => (
              <span key={zip} className="inline-flex items-center gap-1.5 bg-white/15 backdrop-blur-sm text-white px-3 py-1.5 text-xs font-bold rounded-full border border-white/20">
                <i className="ri-map-pin-line" />
                {zip}
              </span>
            ))}
          </div>
        )}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-3 text-sm font-bold uppercase tracking-wider hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {currentLang === "es" ? "Llame al (786) 377-4452" : "Call (786) 377-4452"}
          </a>
          <Link
            to="/contact/"
            className="inline-flex items-center gap-2 border-2 border-white text-white px-8 py-3 text-sm font-bold uppercase tracking-wider hover:bg-white hover:text-[#064e3b] transition-colors whitespace-nowrap"
          >
            {currentLang === "es" ? "Obtener Cotizaci\u00F3n" : "Get Phone Quote"}
          </Link>
        </div>
      </div>
    </section>
  );
}